<template>
  <Modal>
    <div slot="modal-wrapper">
      <div class="max-w-xl min-w-full sm:min-w-30 m-2 mx-auto p-2">
        <transition name="flip" mode="out-in">
          <div v-if="authMethod === 'login'" :key="'login'">
            <SignIn @forgot="authMethod = 'forgot'" @success="$emit('onLoginSuccess')">
              <span slot="header-title">
                Login To Continue!
              </span>
              <span slot="button-title">
                Login & Continue
              </span>
              <div slot="footer" class="text-center mt-5 mb-5">
                <button
                  class="btn btn-secondary rounded-lg block w-full"
                  @click="$emit('onLoginCancel')"
                >
                  Cancel
                </button>
                <a
                  href="javascript:"
                  class="text-primary inline-block mt-8"
                  @click="authMethod = 'signup'"
                >
                  Don't have account? SignUp!!!
                </a>
              </div>
            </SignIn>
          </div>
          <div v-if="authMethod === 'signup'" :key="'signup'">
            <SignUp @success="$emit('onLoginSuccess')">
              <span slot="header-title">
                Signup To Continue!
              </span>
              <span slot="button-title">
                Signup & Continue
              </span>
              <div slot="footer" class="text-center mt-5 mb-5">
                <button
                  class="btn btn-secondary rounded-lg block w-full"
                  @click="$emit('onLoginCancel')"
                >
                  Cancel
                </button>
                <a
                  href="javascript:"
                  class="text-primary inline-block mt-8"
                  @click="authMethod = 'login'"
                >
                  I already have account!!!
                </a>
              </div>
            </SignUp>
          </div>
          <div v-if="authMethod === 'forgot'" :key="'forgot'">
            <ForgotPassword @success="authMethod = 'login'">
              <div slot="footer" class="text-center mt-5 mb-5">
                <button
                  class="btn btn-secondary rounded-lg block w-full"
                  @click="authMethod = 'login'"
                >
                  Cancel
                </button>
              </div>
            </ForgotPassword>
          </div>
        </transition>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import SignIn from "@/components/common/auth/SignIn";
import SignUp from "@/components/common/auth/SignUp";
import ForgotPassword from "@/components/common/auth/ForgotPassword";

export default {
    data() {
        return {
            authMethod: 'login',
        }
    },

    components: {
        ForgotPassword,
        SignUp,
        SignIn,
        Modal
    },

};
</script>

<style></style>
